const n = {
  name: "Unknown",
  dimensions: { width: 20, height: 21 },
  content: `
    <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <rect x="1" y="1.5" width="18" height="18" rx="2"/>
      <path d="M1 13.5L5 9.5L15 19.5"/>
      <circle cx="12.5" cy="8" r="2.5"/>
    </g>
  `
};
export {
  n as Unknown
};
